<template>
  <div
    class="billing-detail"
    :class="{ showTip: showTips(billingDetail.state) }"
  >
    <div v-if="showTips(billingDetail.state)" class="tips">
      <img
        class="tips-icon"
        src="https://res.pandateacher.com/UBCT1WRK1632310281268.png"
        alt=""
      />
      <div class="tips-text">
        {{ computedTipText(billingDetail.state) }}
      </div>
    </div>
    <div class="billing-content">
      <Layout>
        <template slot="content">
          <GoodsInfo :goodsInfo="goodsInfo" isDetail />
          <div class="billing-status">
            <div>普通电子发票</div>
            <span
              class="state-common"
              :style="computedStatusStyle(billingDetail.state)"
            >
              {{ computedStatusText(billingDetail.state) }}
            </span>
          </div>
          <div
            v-if="showPersonalForm && !hideDetail"
            class="billing-relation-info"
          >
            <FormItem
              v-for="personal in personalFormItemOptions"
              :key="personal.field"
              :formdata="billingDetail"
              :options="personal"
            >
            </FormItem>
          </div>
          <div
            v-if="!showPersonalForm && !hideDetail"
            class="billing-relation-info"
          >
            <FormItem
              v-for="enterprise in enterPriseFormItemOptions"
              :key="enterprise.field"
              :formdata="billingDetail"
              :options="enterprise"
            >
            </FormItem>

            <div v-if="showEnterPriseMore">
              <FormItem
                v-for="enterprise in enterPriseExtraOptions"
                :key="enterprise.field"
                :formdata="billingDetail"
                :options="enterprise"
              >
              </FormItem>
            </div>

            <ShowMore :showMore="showEnterPriseMore" @handleMore="handleMore" />
          </div>
          <div v-if="!hideDetail" class="billing-email">
            <div class="label">电子邮箱</div>
            <div class="text">{{ billingDetail.email }}</div>
          </div>
        </template>
        <template slot="footer">
          <div
            v-if="
              invoicingStatusShow(billingDetail.state) ||
              reopenStatusShow(billingDetail.state)
            "
            class="layout-footer"
          >
            <Button
              v-if="invoicingStatusShow(billingDetail.state)"
              text="修改申请"
              class="edit-btn"
              flexlayout
              @click="handleEditApply(billingDetail.state)"
            />
            <Button
              v-if="invoicingStatusShow(billingDetail.state)"
              class="reset-btn"
              flexlayout
              text="撤销申请"
              @click="handleResetClick"
            />
            <Button
              v-if="reopenStatusShow(billingDetail.state)"
              :text="
                otherStatusText(billingDetail.state, billingDetail.card_status)
              "
              :background="
                otherStatusBack(billingDetail.state, billingDetail.card_status)
              "
              @click="handleOtherClick(billingDetail.state)"
            />
          </div>
        </template>
      </Layout>
    </div>

    <ResetComfirm
      v-model="showResetPop"
      @handleResetComfirm="handleResetComfirm"
    />
  </div>
</template>


<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator';
import Layout from '../../common/Layout.vue';
import Button from '../../common/Button.vue';
import GoodsInfo from '../../common/GoodsInfo.vue';
import ResetComfirm from './components/ResetComfirm.vue';
import ShowMore from '../../common/ShowMore.vue';
import BillingSystemMixins from '../../mixin/mixins';
import FormItem from './components/FormItem.vue';
import { Route } from 'vue-router';
import {
  IBillingDetail,
  IGoodsInfo,
  headerTypeEnum,
  headerTypeObject,
  billingStatusObject,
  resetStateEnum,
  errcodeEnum,
  statusEnum,
  cardStatusEnum,
  pageShowStatusEnum,
  cardStatusText,
} from '../../billingSystem';
import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';

@Component({
  components: {
    Layout,
    Button,
    FormItem,
    GoodsInfo,
    ResetComfirm,
    ShowMore,
  },
  beforeRouteEnter(to: Route, from: Route, next: Function) {
    next(async (vm: BillingDetail) => {
      window.Al.start();
      window.np.start();
      await vm.getInvoiceDetail();
      await vm.getInvoiceOrderSingle();
      window.Al.done();
      window.np.done();
    });
  },
})
export default class BillingDetail extends Mixins(BillingSystemMixins) {
  headerType = headerTypeObject.personal;
  showEnterPriseMore: Boolean = false;
  showResetPop: Boolean = false;
  billingDetail: IBillingDetail = {
    id: 1,
    state: statusEnum.committed,
    invoice_status: 1,
    pay_amount: 0,
    paid_time: 1,
    invoice_amount: 1,
    production_name: '',
    apply_time: 1,
    invoice_time: 1,
    title_type: '',
    title_name: '',
    tax_code: '',
    email: '',
    organization_address: '',
    organization_tel: '',
    bank_name: '',
    bank_account: '',
    order_no: '',
    order_id: '',
    card_status: 1,
    we_chat_card_url: '',
  };
  goodsInfo: IGoodsInfo = {
    goodsName: '',
    goodsOrderCode: '',
    goodsOrderTime: 0,
    goodsOrderMoney: 0,
    goodsInvoiceAmount: 0,
  };
  enterPriseFormItemOptions = [
    {
      label: '开票金额',
      field: 'invoice_amount',
      needFormat: true,
      format: this.transformMoney,
      extraClass: 'billing-money',
      beforeTip: '¥',
    },
    {
      label: '申请时间',
      field: 'apply_time',
      needFormat: true,
      format: this.formatTime,
      extraClass: '',
      beforeTip: '',
    },
    {
      label: '开具时间',
      field: 'invoice_time',
      needFormat: true,
      format: this.formatTime,
      extraClass: '',
      beforeTip: '',
    },
    {
      label: '发票抬头',
      field: 'title_name',
      needFormat: false,
      format: () => {},
      extraClass: '',
      beforeTip: '',
    },
    {
      label: '税号',
      field: 'tax_code',
      needFormat: true,
      format: this.formatStr,
      extraClass: '',
      beforeTip: '',
    },
  ];
  enterPriseExtraOptions = [
    {
      label: '企业地址',
      field: 'organization_address',
      needFormat: false,
      format: () => {},
      extraClass: '',
      beforeTip: '',
    },
    {
      label: '企业电话',
      field: 'organization_tel',
      needFormat: false,
      format: () => {},
      extraClass: '',
      beforeTip: '',
    },
    {
      label: '开户银行',
      field: 'bank_name',
      needFormat: false,
      format: () => {},
      extraClass: '',
      beforeTip: '',
    },
    {
      label: '银行账号',
      field: 'bank_account',
      needFormat: true,
      format: this.formatStr,
      extraClass: '',
      beforeTip: '',
    },
  ];
  personalFormItemOptions = [
    {
      label: '开票金额',
      field: 'invoice_amount',
      needFormat: true,
      format: this.transformMoney,
      extraClass: 'billing-money',
      beforeTip: '¥',
    },
    {
      label: '申请时间',
      field: 'apply_time',
      needFormat: true,
      format: this.formatTime,
      extraClass: '',
      beforeTip: '',
    },
    {
      label: '开具时间',
      field: 'invoice_time',
      needFormat: true,
      format: this.formatTime,
      extraClass: '',
      beforeTip: '',
    },
    {
      label: '发票抬头',
      field: 'title_name',
      needFormat: false,
      format: () => {},
      extraClass: '',
      beforeTip: '',
    },
  ];

  get showTips() {
    return (state: statusEnum) => {
      if (!state) return '';
      return (
        billingStatusObject[state].pageShowStatus ===
          pageShowStatusEnum.voided ||
        billingStatusObject[state].pageShowStatus ===
          pageShowStatusEnum.invoiceError ||
        state === statusEnum.committed
      );
    };
  }

  get showPersonalForm() {
    return this.headerType === headerTypeObject.personal;
  }

  get hideDetail() {
    return (
      this.billingDetail.state === statusEnum.oldData &&
      !this.billingDetail.invoice_time
    );
  }

  get computedStatusText() {
    return (state: statusEnum) => {
      if (!state) return '';
      return billingStatusObject[state].text;
    };
  }

  get computedStatusStyle() {
    return (state: statusEnum) => {
      if (!state) return '';
      return {
        background: billingStatusObject[state].class.background,
        color: billingStatusObject[state].class.color,
      };
    };
  }

  get computedTipText() {
    return (state: statusEnum) => {
      if (!state) return '';

      const textMap = [
        {
          condiation: [
            statusEnum.committed,
            statusEnum.blue_error_mail,
            statusEnum.blue_error_title_tax,
            statusEnum.blue_error_other,
          ].includes(state),
          text: billingStatusObject[state].tipText,
        },
        {
          condiation:
            billingStatusObject[state].pageShowStatus ===
            pageShowStatusEnum.voided,
          text: '该订单已退款，发票已作废。',
        },
        {
          condiation:
            billingStatusObject[state].pageShowStatus ===
            pageShowStatusEnum.invoiceError,
          text: '该订单已退款，请重新申请开票。',
        },
      ];

      return textMap.find((item) => item.condiation)?.text || '';
    };
  }

  get invoicingStatusShow() {
    return (state: statusEnum) => {
      if (!state) return false;
      return state === statusEnum.committed || state === statusEnum.edited;
    };
  }

  get reopenStatusShow() {
    return (state: statusEnum) => {
      if (!state) return false;
      return billingStatusObject[state].reopen;
    };
  }

  get formatStr() {
    return (str: string) => {
      if (!str) return '-';
      return this.utilHandleStr(str);
    };
  }

  get otherStatusText() {
    return (state: statusEnum, cardState: cardStatusEnum) => {
      if (!state) return '';
      if (
        billingStatusObject[state].pageShowStatus ===
        pageShowStatusEnum.invoiceSuccess
      ) {
        return cardStatusText[cardState];
      }
      return '重新申请开票';
    };
  }

  get otherStatusBack() {
    return (state: statusEnum, cardState: cardStatusEnum) => {
      if (!state) return '';
      if (
        billingStatusObject[state].pageShowStatus ===
          pageShowStatusEnum.invoiceSuccess &&
        cardState === cardStatusEnum.Received
      ) {
        return 'rgba(117, 89, 216,.3)';
      }
      return '#6741EF';
    };
  }

  handleEditApply() {
    this.handleRouteLinkTo('billingApply', {
      type: 'edit',
      id: this.$route.params.OrderId,
    });
  }

  handleResetClick() {
    this.showResetPop = true;
  }

  handleMore() {
    this.showEnterPriseMore = !this.showEnterPriseMore;
  }

  async getInvoiceDetail() {
    const params = {
      OrderId: this.$route.params.OrderId,
    };
    try {
      const { data } = await window.apis.getInvoiceDetail(params);
      this.getGoodsInfo(data);
      this.billingDetail = data;
      this.headerType = headerTypeObject[data.title_type as headerTypeEnum];
    } catch (error) {
      console.log('error', error);
    }
  }

  handleResetComfirm() {
    // todo 确认撤销
    this.putInvoiceInvoicesCancel();
  }

  async putInvoiceInvoicesCancel() {
    const { errcode } = await window.apis.putInvoiceInvoicesCancel(
      {},
      {
        id: this.billingDetail.id,
      }
    );
    const name =
      errcode === errcodeEnum.success
        ? resetStateEnum.billingResetSuccess
        : resetStateEnum.billingResetError;
    this.handleRouteLinkTo(name, {
      OrderId: this.$route.params.OrderId,
    });
  }

  async handleOtherClick(state: statusEnum) {
    if (
      billingStatusObject[state].pageShowStatus ===
      pageShowStatusEnum.invoiceSuccess
    ) {
      if (this.billingDetail.card_status) return;
      if (!this.billingDetail.we_chat_card_url)
        return Toast({
          className: 'billing-toast',
          forbidClick: true,
          message: '领取异常',
        });
      location.href = this.billingDetail.we_chat_card_url;
    } else {
      const invoiceAmount = await this.checkAmount(this.$route.params.OrderId);
      if (
        !this.handleNoAmountLink(
          invoiceAmount,
          billingStatusObject[state].toast
        )
      )
        return;
      this.handleRouteLinkTo('billingApply', {
        type: 'edit',
        id: this.$route.params.OrderId,
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/index.scss';
.billing-detail {
  min-height: 100%;
  background-color: $_app_backgroup;
}
.billing-detail.showTip {
  padding-top: 72px;
}
.billing-content {
  padding: 24px 32px 150px;
}
.billing-status,
.billing-email {
  @include flex_layout(center, space-between);
  margin-top: 24px;
  padding: 32px;
  color: $_gray_color;
  font-size: 28px;
  font-family: $_reg_famliy;
  background-color: $_white_color;
  border-radius: 16px;
  .state-common {
    padding: 4px 12px;
    font-size: 22px;
    border-radius: 6px;
  }
}
.billing-relation-info {
  margin-top: 24px;
  padding: 32px 32px 2px;
  font-size: 28px;
  background-color: $_white_color;
  border-radius: 16px;
}
.billing-status {
  color: $_base_color;
}
.billing-email {
  justify-content: unset;
  color: $_label_color;
  .label {
    min-width: 128px;
    margin-right: 28px;
  }
  .text {
    color: $_base_color;
  }
}
.tips {
  @include fixed_nav(top, 72px, #fffbe5, 33px, none);
}
.tips .tips-icon {
  width: 32px;
  height: 32px;
}
.tips .tips-text {
  margin-left: 16px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 28px;
  font-family: $_reg_famliy;
}
.layout-footer {
  @include fixed_nav(bottom, 136px, $_white_color, 0, space_around);
}
.layout-footer .edit-btn {
  color: $_base_light_purple;
  background: $_white_color;
  border: 1px solid $_base_light_purple;
}
.layout-footer .reset-btn {
  background: $_base_light_purple;
}
</style>
